/**
 * Public campaign card for listing grid (M15).
 */
import { Link } from "react-router-dom"
import { CampaignProgressBar } from "@/components/campaigns/CampaignProgressBar"
import { Card, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import type { Tables } from "@/types/database"

type CampaignRow = Tables<"campaigns">

export interface CampaignCardProps {
  campaign: CampaignRow
  raisedCents: number
  basePath: string
  primaryColor: string
  daysRemaining: number | null
  ended: boolean
}

export function CampaignCard({
  campaign,
  raisedCents,
  basePath,
  primaryColor,
  daysRemaining,
  ended,
}: CampaignCardProps) {
  const href = `${basePath}/campaign/${campaign.slug}`
  const cover = campaign.cover_image_url

  return (
    <Card className="overflow-hidden flex flex-col" data-testid={`campaign-card-${campaign.slug}`}>
      <div
        className="h-36 w-full bg-muted bg-cover bg-center"
        style={
          cover
            ? { backgroundImage: `url(${cover})` }
            : { background: `linear-gradient(135deg, ${primaryColor}, #1e293b)` }
        }
      />
      <CardContent className="flex flex-1 flex-col gap-3 pt-4">
        <div className="flex items-start justify-between gap-2">
          <h2 className="text-lg font-semibold leading-tight">{campaign.title}</h2>
          {ended ? (
            <Badge variant="secondary">Campaign ended</Badge>
          ) : daysRemaining != null && daysRemaining >= 0 ? (
            <Badge variant="outline">{daysRemaining} days left</Badge>
          ) : null}
        </div>
        <CampaignProgressBar
          raisedCents={raisedCents}
          goalCents={campaign.goal_cents}
          variant="compact"
          ended={ended}
        />
        <Button variant="default" className="mt-auto w-full sm:w-auto self-start" asChild>
          <Link to={href}>Support This Campaign →</Link>
        </Button>
      </CardContent>
    </Card>
  )
}
